declare namespace $ {

	type $shm_file_drop__files_shm_hitalama_file_attach_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_file_attach['files'] >
		,
		ReturnType< $shm_file_drop['files'] >
	>
	type $mol_paragraph__title_shm_hitalama_file_attach_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_file_attach['filename'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_shm_hitalama_file_attach_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_file_attach_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_file_attach['file_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_file_attach_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_file_attach extends $mol_view {
		file_dragover( next?: any ): any
		file_drop( next?: any ): any
		files( next?: readonly(any)[] ): readonly(any)[]
		File( ): $shm_file_drop
		filename( ): string
		Name( ): $mol_paragraph
		file_delete( next?: any ): any
		Delete( ): $mol_button_minor
		Delete_row( ): $mol_view
		delete_visible( ): readonly(any)[]
		value( next?: string ): string
		event( ): ({ 
			dragover( next?: ReturnType< $shm_hitalama_file_attach['file_dragover'] > ): ReturnType< $shm_hitalama_file_attach['file_dragover'] >,
			drop( next?: ReturnType< $shm_hitalama_file_attach['file_drop'] > ): ReturnType< $shm_hitalama_file_attach['file_drop'] >,
		})  & ReturnType< $mol_view['event'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=attach.view.tree.d.ts.map